import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '../../../../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../../../models/user';
import { UserPromotionVoucher } from '../../../../models/user-promotion-voucher';
import { UserPromotionVoucherService } from '../../../../shared/services/user-promotion-voucher.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-voucher-success',
    templateUrl: './voucher-success.component.html',
    styleUrls: ['./voucher-success.component.scss'],
})
export class VoucherSuccessComponent implements OnInit {
    brandName: string;
    error: any;
    isLoading = false;

    async ngOnInit(): Promise<void> {
        await this.loadVoucherData();
    }

    private async loadVoucherData(): Promise<void> {
        try {
            this.isLoading = true;
            this.brandName = localStorage.getItem('brandName');
        } catch (e) {
            this.error = e;
        } finally {
            this.isLoading = false;
        }
    }

    clearLocalStorage() {
        localStorage.removeItem('brandName');
    }
}
